import React from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";
import ErrorBoundary from './toolympus/components/app/ErrorBoundary';
import AppRouter from './AppRouter';

import { Providers } from './Providers';
import { LoginContainer, SignupContainer, ResetPasswordContainer, RestorePasswordContainer, LoginKCStart, LoginOTP, LoginKCComplete } from './components/Auth';

const App: React.FC = () => {
    return (
        <Providers>
            <Router>
                <ErrorBoundary>
                    <Switch>
                        <Route path='/signup' component={SignupContainer} />
                        <Route path='/login-kc-start' component={LoginKCStart} />
                        <Route path='/login-kc' component={LoginKCComplete} />
                        <Route path='/login' component={LoginOTP} />
                        <Route path='/login-pass' component={LoginContainer} />
                        <Route path='/reset' component={ResetPasswordContainer} />
                        <Route path='/restore-password' component={RestorePasswordContainer} />
                        <Route path='/' component={AppRouter} />
                    </Switch>
                </ErrorBoundary>
            </Router>
        </Providers>
    );
}

export default App;